/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BoundTaskRefTaskTitle } from './boundTaskRefTaskTitle';
import type { BoundTaskRefModuleTitle } from './boundTaskRefModuleTitle';

/**
 * Display projection for a slot's bound task.

This is a denormalized, read-only view combining task and module labels to
help clients render cross-module sessions clearly.
 */
export interface BoundTaskRef {
  taskId: string;
  taskTitle?: BoundTaskRefTaskTitle;
  moduleId: string;
  moduleTitle?: BoundTaskRefModuleTitle;
}
